import { lazy } from 'react';
import ComponentLoader from 'src/components/ComponentLoader';
import Module from 'src/config/models/Module';
import ModuleBundle from 'src/config/models/ModuleBundle';

export const AlertViewModule = new Module({
  id: 'ALERT:RESULT-TABLE',
  name: 'Alert',
  label: 'Alerts',
  path: 'alert',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/Alert/View'))
  ),
  actions: {
    edit: {
      id: 'ALERT:VIEW:*',
      name: 'VIEW',
      label: 'View'
    },
    delete: {
      id: 'alert-delete',
      name: 'delete',
      label: 'Delete'
    }
  }
});

export const AlertAddModule = new Module({
  id: 'ALERT:ADD:*',
  name: 'alertAdd',
  path: 'alert/add',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/Alert/Form'))
  ),
  actions: {
    add: {
      id: 'ALERT:ADD:*',
      name: 'Alert Add',
      label: 'Add Alert'
    }
  }
});

export const AlertEditModule = new Module({
  id: 'ALERT:VIEW:DETAILS',
  name: 'Alert Edit',
  path: 'alert/details/:alertId',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/Alert/Form'))
  )
});

const AlertModules = [
  AlertViewModule,
  AlertAddModule,
  AlertEditModule
];

export default new ModuleBundle('Alert', AlertModules);
